import { cn } from "@/utils";

/** Shared compact rail glyph button — section +/⋯ menus, size-6. */
export const railIconButtonClassName = cn(
  "inline-flex size-6 shrink-0 items-center justify-center rounded-md text-n-50 hover:bg-n-10 hover:text-n-80",
);
